import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@core/core.module';
import { IS_HUB_LITE } from '@core/hubconfig';
import { AppState } from '@core/store/application/application.state';
import { EntityNamesState } from '@core/store/entity-names/entity-names.state';
import { NavbarState } from '@core/store/navbar/navbar.state';
import { UserState } from '@core/store/user/user.state';
import { environment } from '@env';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxsModule } from '@ngxs/store';
import { HubLoadingSpinnerModule } from '@shared/components/hub-loading-spinner/hub-loading-spinner.module';
import { provideMonacoEditorConfig } from '@core/utils/monaco-embed';
import { provideHubAccount } from '@core/services/ol-account/ol-account.providers';
import { AppEnterpriseModule } from './app-enterprise.module';
import { AppLiteHubModule } from './app-lite-hub.module';
import { AppMainModule } from './app-main.module';
import { AppComponent } from './app.component';

const APP_MODE_MODULE = environment.enterprise
  ? AppEnterpriseModule
  : IS_HUB_LITE
    ? AppLiteHubModule
    : AppMainModule;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    NgxsModule.forRoot(
      [AppState, UserState, NavbarState, EntityNamesState],
      {
        developmentMode: !environment.production,
        compatibility: {
          strictContentSecurityPolicy: true,
        },
      },
    ),
    NoopAnimationsModule,
    environment.plugins,
    NgSelectModule,
    APP_MODE_MODULE,
    HubLoadingSpinnerModule,
  ],
  providers: [
    provideHubAccount('hub', '/account'),
    // Root-level so kit-hosted account sections (which resolve against the
    // root injector) can create <ngx-monaco-editor> — see monaco-embed.ts.
    provideMonacoEditorConfig(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
